import { InsightData } from 'schemas/action/InsightDataSchema'
import { Filter } from 'schemas/FilterSchema'
import { SearchFilterComposingStrategy } from './searchFilterComposingStrategy'
import { pivotTagDecorator } from './decorator'
import generateStaticStrategy from './staticStrategy'

const composeDetailSearchFilter = (filter: Filter, insights: InsightData[]) => {
  const staticStrategy = generateStaticStrategy()
  const decoratedStrategy = pivotTagDecorator(staticStrategy)
  return decoratedStrategy.composeDetailSearchFilter(filter, [], insights)
}

const generatePivotTagStrategy = (): SearchFilterComposingStrategy => ({
  composeDetailSearchFilter
})

export default generatePivotTagStrategy
